var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"foot foot1"},[_vm._m(0),_c('div',{staticClass:"beian"},[_c('span',{on:{"click":_vm.beian}},[_vm._v("蜀ICP备18038614号-2")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-foot"},[_c('div',[_vm._v("版权所有")]),_c('img',{attrs:{"src":"https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/common/images/official-website/imgs/logo.png","alt":""}})])
}]

export { render, staticRenderFns }